export default {
  main: '#080404',
  secondary: '#FF00E7',
  contrastingColor: '#ffffff',
  priceColor: '#080404',
  entryBackground: '#000000',
  menuBackgroundColor: '#ffffff',
  menuTextColor: '#000000',
};
